export default {
  methods: {
    $filterHeaders(headers) {
      return headers.filter((s) => !s.hideable || (s.hideable && s.show));
    },
  },
};
